class SearchView {
  // _searchForm;
  // _inputField;

  constructor(searchForm, inputField) {
    this._searchForm = document.querySelector(searchForm);
    this._inputField = this._searchForm.querySelector(inputField);
  }

  addHandlerSearch(handler) {
    this._searchForm.addEventListener('submit', e => {
      e.preventDefault();
      handler();
    });
  }

  getQuery() {
    const query = this._inputField.value.trim();
    this._resetForm();
    return query;
  }

  _resetForm() {
    this._searchForm.reset();
  }
}

export default new SearchView('.search', '.search__field');
